import React, { useState, useEffect } from "react";
import ApiService from '../../../../services/apiService';
import { useTranslation } from 'react-i18next';
import Select from 'react-select';
import moment from "moment";


const DayReports = () => {
    const [data, setData] = useState([]);
    const [pagination, setPagination] = useState();
    const { t } = useTranslation();
    const getFormattedDate = (date) => {
        return new Date(date).toISOString().slice(0, 16); // Returns format "YYYY-MM-DDTHH:mm"
    };

    const today = new Date();
    const tenDaysAgo = new Date();
    tenDaysAgo.setDate(today.getDate() - 10);

    const [formData, setFormData] = useState({
        reportType: [],
        fromDate: getFormattedDate(tenDaysAgo),
        toDate: getFormattedDate(today),
    });

    const reportTypes = [
        { label: "All", value: "All" },
        { label: "Day Open", value: "DayOpen" },
        { label: "Day Close", value: "DayClose" },
    ];
    const totalAmount = data?.reduce((sum, row) => sum + (parseFloat(row?.initialBalance) || 0), 0)
    const total = data?.reduce((sum, row) => sum + (parseFloat(row?.finalBalance) || 0), 0)

    const getReportData = async (newPageNo = pagination?.currentPage) => {
        try {
            const apiService = new ApiService
            const params = new URLSearchParams();
            params.append('ReportType', formData?.reportType?.value || "All");
            params.append('StartDate', formData?.fromDate);
            params.append('EndDate', formData?.toDate);
            const res = await apiService.getApiParamater('GET_CASH_REPORT', `?${params.toString()}`);
            if(res?.data?.statusCode===204){
                setData(null);
            }else{
                setData(res?.data?.result.reverse() || []);
                setPagination(res.data.paginationData);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const handleReportType = (selectedOption) => {
        setFormData({ ...formData, reportType: selectedOption });
    }

    const handleInputChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    }
    return (
        <div className='p-5'>
            <div className='row'>
                <div className='col-3'>
                    <label htmlFor="validationCustom01" className="form-label w-50">{t('from')} {t('date')}</label>
                    <input type='datetime-local' className="form-control" value={formData?.fromDate} onChange={handleInputChange} name='fromDate' />
                </div>
                <div className='col-3'>
                    <label htmlFor="validationCustom01" className="form-label w-50">{t('to')} {t('date')}</label>
                    <input type='datetime-local' className="form-control" value={formData?.toDate} onChange={handleInputChange} name='toDate' />
                </div>
                <div className='col-3'>
                    <label htmlFor="validationCustom01" className="form-label">Type</label>
                    <Select
                        styles={{
                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                            option: (provided, state) => ({
                                ...provided,
                                backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                color: state.isFocused ? '#000 ' : '#000',
                                ':hover': {
                                    backgroundColor: '#F5F5F5',
                                    color: '#000 ',
                                },
                            }),
                        }}
                        menuPlacement="auto"
                        menuShouldScrollIntoView={false}
                        menuPortalTarget={document.body}
                        value={formData?.ReportType}
                        options={reportTypes}
                        onChange={handleReportType}
                    />
                </div>
                <div className='col-3 mt-3'>
                    <button className=' mt-3 addItem-btn' type="submit" onClick={getReportData}>{t('search')}</button>
                </div>
            </div>
            <div className="POsgridshad rounded p-4 mt-5">
                <div className="custom-table-container">
                    <table className="custom-table">
                        <thead>
                        <tr>
                                <th>{t('report_type')}</th>
                                <th>{t('branches')} {t('name')} </th>
                                <th>{t('counter')} {t('name')} </th>
                                <th>{t('employeeName')}</th>
                                <th>{t('time')}</th>
                                <th>{t('Opening Balance')}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data?.map((item, index) => (
                                <tr>
                                    <td>{item?.reportType || "---"}</td>
                                    <td>{item?.branchName || "---"}</td>
                                    <td>{item?.counterName || "---"}</td>
                                    <td>{item?.employeeName || "---"}</td>
                                    <td>{moment(item?.eventTime).format("lll") || "---"}</td>
                                    <td>{item?.finalBalance?.toFixed(2) || "---"}</td>
                                </tr>
                            ))}
                        </tbody>
                        <tfoot>
                            <tr className="bg-green-100 font-bold">
                                <td colSpan={5} className="text-end">{t('subtotal')}</td>
                                <td>{totalAmount?.toFixed(2) || "---"}</td>
                            </tr>
                            <tr className="bg-green-100 font-bold">
                                <td colSpan={5} className="text-end">{t('total')} {t('amount')}</td>
                                <td>{total?.toFixed(2) || "---"}</td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default DayReports;